import { createScopedDescriptor, set } from 'quartz-core-utils/globalState/api';
import userInfo from 'hub-http/userInfo';
import PortalIdParser from 'PortalIdParser';
import { applyQueryParamOverrides } from './queryParamUtils';
// Create a silo property to store the result of the auth tool's setup
export const APP_AUTH_RESULT = createScopedDescriptor('appAuthResult', 'EXECUTION_CONTEXT');
export async function initializeAppAuth({
  queryParams,
  allowSuspended
}) {
  // HACK: userInfo depends PortalIdParser.get() setting
  // the global window.hubspot.portal.id
  PortalIdParser.get();
  const userInfoResult = await userInfo({
    allowSuspended
  });
  const scopes = new Set(userInfoResult.user.scopes);
  const gatesWithQueryParamOverrides = applyQueryParamOverrides(userInfoResult.gates, queryParams);
  const gates = new Set(gatesWithQueryParamOverrides);
  const result = {
    // Applies query param overrides to the top-level gates array
    auth: Object.assign({}, userInfoResult, {
      gates: gatesWithQueryParamOverrides
    }),
    scopes,
    gates
  };
  set(APP_AUTH_RESULT, result);
  return result;
}